import script from "./PracticeAreaEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./PracticeAreaEdit.vue?vue&type=script&setup=true&lang=js"

import "./PracticeAreaEdit.vue?vue&type=style&index=0&id=301d0692&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-301d0692"]])

export default __exports__